export default "__VITE_ASSET__tZx6FFAr__"